(() => {
  if (document.body.classList.contains("is-505")) return;
  const seal = document.querySelector("[data-seal]");
  if (!seal) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const home = seal.querySelector("[data-seal-home]");
  const sfx = (name) => {
    if (window.FH && typeof window.FH.playSfx === "function") window.FH.playSfx(name);
  };

  const MW = 480;
  const MH = Math.round(MW * 2073 / 3000);
  const PIVOT_X = 0.5;
  const PIVOT_Y = 0.526;
  const FLY_PAD = 0.28;
  const REMAIN_ROT = 14;
  const REMAIN_TX = 0.07;
  const REMAIN_TY = 0.05;
  const mark = seal.closest(".os-mark");
  const depthBuf = document.createElement("canvas");
  depthBuf.className = "os-seal__depth";
  depthBuf.setAttribute("aria-hidden", "true");
  home.insertBefore(depthBuf, home.firstChild);
  const depthCtx = depthBuf.getContext("2d");
  const buf = document.createElement("canvas");
  buf.className = "os-seal__buf";
  home.insertBefore(buf, depthBuf.nextSibling);
  const ctx = buf.getContext("2d");
  let tmpRed = null;
  let depthRaf = 0;
  let lookX = 0;
  let lookY = 0;
  let lookTX = 0;
  let lookTY = 0;
  const depthCfg = { tilt: 0.07, depth: 1.4, glow: 1.13, idle: 0, layers: 12 };

  const parts = [...home.querySelectorAll(".os-seal__layer")].map((el) => ({
    el,
    part: el.getAttribute("data-part"),
    side: el.getAttribute("data-side"),
    artSrc: el.querySelector("img") ? el.querySelector("img").getAttribute("src") : "",
    maskSrc: el.getAttribute("data-mask") || "",
    art: null,
    mask: null,
    ink: null
  }));
  const sides = {
    left: parts.filter((p) => p.side === "left"),
    right: parts.filter((p) => p.side === "right")
  };
  const maskBuf = { left: [], right: [] };
  const flies = { left: null, right: null };
  const gone = { left: false, right: false };
  let holding = null;
  let rebuilding = false;
  let rebuildTimer = 0;
  let physRaf = 0;
  let flickerRaf = 0;
  let lastT = 0;
  let flyZ = 0;
  let drop = null;
  let ripTimer = 0;
  let remainT0 = 0;

  const absUrl = (src) => {
    if (!src) return "";
    const trimmed = src.trim();
    if (trimmed.startsWith("//")) return "https:" + trimmed;
    return trimmed;
  };

  const cssUrl = (el) => {
    const raw = getComputedStyle(el).getPropertyValue("--seal-mask").trim();
    const m = raw.match(/url\((?:["']?)(.+?)(?:["']?)\)/i);
    return m ? absUrl(m[1]) : "";
  };

  const loadImg = (src) => new Promise((resolve, reject) => {
    const url = absUrl(src);
    if (!url) return reject(new Error("img"));
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(url));
    img.src = url;
  });

  const raster = (img) => {
    const c = document.createElement("canvas");
    c.width = MW;
    c.height = MH;
    const g = c.getContext("2d", { willReadFrequently: true });
    g.drawImage(img, 0, 0, MW, MH);
    return g.getImageData(0, 0, MW, MH).data;
  };

  const stripBlack = (img) => {
    const sw = img.naturalWidth || img.width;
    const sh = img.naturalHeight || img.height;
    const tmp = document.createElement("canvas");
    tmp.width = sw;
    tmp.height = sh;
    const tg = tmp.getContext("2d", { willReadFrequently: true });
    tg.drawImage(img, 0, 0);
    let id;
    try {
      id = tg.getImageData(0, 0, sw, sh);
    } catch (_) {
      return tmp;
    }
    const d = id.data;
    for (let i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 18) continue;
      const lum = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
      if (lum < 18) d[i + 3] = 0;
    }
    tg.putImageData(id, 0, 0);
    const maxW = 1400;
    if (sw <= maxW) return tmp;
    const c = document.createElement("canvas");
    c.width = maxW;
    c.height = Math.round(maxW * sh / sw);
    c.getContext("2d").drawImage(tmp, 0, 0, c.width, c.height);
    return c;
  };

  const sizeCanvas = (canvas, pad) => {
    const r = seal.getBoundingClientRect();
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = Math.max(1, Math.round(r.width * dpr));
    const h = Math.max(1, Math.round(r.height * dpr));
    const pw = Math.max(1, Math.round(w * (1 + 2 * pad)));
    const ph = Math.max(1, Math.round(h * (1 + 2 * pad)));
    if (canvas.width !== pw || canvas.height !== ph) {
      canvas.width = pw;
      canvas.height = ph;
    }
    canvas.style.width = (r.width * (1 + 2 * pad)) + "px";
    canvas.style.height = (r.height * (1 + 2 * pad)) + "px";
    canvas.style.left = (-pad * 100) + "%";
    canvas.style.top = (-pad * 100) + "%";
    return { w, h, ox: (pw - w) / 2, oy: (ph - h) / 2, cssW: r.width, cssH: r.height };
  };

  const sizeBuf = () => {
    const pad = remainTilt() ? FLY_PAD : 0;
    const dims = sizeCanvas(buf, pad);
    sizeCanvas(depthBuf, pad);
    return dims;
  };

  const staleWings = (w) => w && (
    (Number(w.glow) === 0.7 && Number(w.depth) === 0.34) ||
    (Number(w.tilt) === 0.15 && Number(w.depth) === 0.75 && Number(w.glow) === 0.99)
  );

  const readLabWings = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem("fh-lab-v6") || "null");
      const w = parsed && parsed.wings;
      return staleWings(w) ? null : w;
    } catch (_) {
      return null;
    }
  };

  const mergeWings = (w) => {
    if (!w || staleWings(w)) return false;
    let dirty = false;
    ["tilt", "depth", "glow", "idle", "layers"].forEach((k) => {
      const n = Number(w[k]);
      if (!Number.isFinite(n) || depthCfg[k] === n) return;
      depthCfg[k] = n;
      dirty = true;
    });
    return dirty;
  };

  const depthVisible = () => {
    if (reduced) return false;
    if (!seal.classList.contains("is-composited")) return false;
    if (home.classList.contains("is-fallen")) return false;
    if (rebuilding) return false;
    return true;
  };

  const redTmp = (w, h) => {
    if (!tmpRed) tmpRed = document.createElement("canvas");
    if (tmpRed.width !== w || tmpRed.height !== h) {
      tmpRed.width = w;
      tmpRed.height = h;
    }
    return tmpRed;
  };

  const paintDepth = () => {
    const { w, h, ox, oy } = sizeBuf();
    depthCtx.setTransform(1, 0, 0, 1, 0, 0);
    depthCtx.clearRect(0, 0, depthBuf.width, depthBuf.height);
    if (!depthVisible()) return;
    ensureInk();
    const now = performance.now() * 0.001;
    const idle = depthCfg.idle * (innerWidth <= 900 ? 2.2 : 1);
    const lx = lookX + Math.sin(now * 0.55) * idle;
    const ly = lookY + Math.cos(now * 0.41) * idle * 0.7;
    const phone = innerWidth <= 900;
    const nRaw = depthCfg.layers > 0 ? Math.round(depthCfg.layers) : (phone ? 8 : 11);
    const layers = Math.max(4, Math.min(24, nRaw));
    const halo = haloMulNow();
    const tmp = redTmp(w, h);
    const tg = tmp.getContext("2d");
    withRemainXform(depthCtx, ox, oy, w, h, () => {
      for (let i = 0; i < layers - 1; i += 1) {
        const back = 1 - i / Math.max(1, layers - 1);
        const tDepth = (i + 1) / layers;
        const px = -lx * w * 0.1 * back * depthCfg.depth;
        const py = ly * h * 0.08 * back * depthCfg.depth;
        const alpha = (0.42 + tDepth * 0.18) * depthCfg.glow;
        tg.setTransform(1, 0, 0, 1, 0, 0);
        tg.clearRect(0, 0, w, h);
        parts.forEach((p) => {
          if (p.el.classList.contains("is-away")) return;
          drawPart(tg, p, 0, 0, w, h, p.part === "halo" ? halo : 1, true);
        });
        tg.globalCompositeOperation = "source-in";
        tg.fillStyle = i % 2 ? "#5a0610" : "#cc1e1e";
        tg.fillRect(0, 0, w, h);
        tg.globalCompositeOperation = "source-over";
        depthCtx.globalAlpha = alpha;
        depthCtx.drawImage(tmp, px, py);
      }
      depthCtx.globalAlpha = 1;
    });
  };

  const depthTick = () => {
    lookX += (lookTX - lookX) * 0.14;
    lookY += (lookTY - lookY) * 0.14;
    paintDepth();
    depthRaf = requestAnimationFrame(depthTick);
  };

  const startDepth = () => {
    mergeWings(readLabWings());
    if (mark) mark.classList.add("is-3d");
    if (depthRaf || reduced) return;
    depthRaf = requestAnimationFrame(depthTick);
  };

  const ensureInk = () => {
    parts.forEach((p) => {
      if (p.art && !p.ink) p.ink = stripBlack(p.art);
    });
  };

  const drawPart = (g, p, dx, dy, w, h, haloMul, occupy) => {
    if (occupy && p.mask) {
      g.globalCompositeOperation = "destination-out";
      g.globalAlpha = 1;
      g.drawImage(p.mask, dx, dy, w, h);
    }
    g.globalCompositeOperation = "source-over";
    g.globalAlpha = p.part === "halo" ? haloMul : 1;
    const src = p.ink || p.art;
    if (src) g.drawImage(src, dx, dy, w, h);
    g.globalAlpha = 1;
  };

  const punchParts = (g, list, dx, dy, w, h) => {
    g.globalCompositeOperation = "destination-out";
    g.globalAlpha = 1;
    list.forEach((p) => {
      if (p.mask) g.drawImage(p.mask, dx, dy, w, h);
    });
    g.globalCompositeOperation = "source-over";
  };

  const remainSide = () => {
    if (seal.classList.contains("is-right-gone") && !seal.classList.contains("is-left-gone")) return "right";
    if (seal.classList.contains("is-left-gone") && !seal.classList.contains("is-right-gone")) return "left";
    return null;
  };

  const remainTilt = () => !!remainSide();

  const remainSign = () => (remainSide() === "left" ? -1 : 1);

  const remainAmt = () => {
    if (!remainTilt()) return 0;
    if (reduced) return 1;
    const u = Math.min(1, (performance.now() - remainT0) / 550);
    return 1 - Math.pow(1 - u, 3);
  };

  const withRemainXform = (g, dx, dy, w, h, fn) => {
    const k = remainAmt();
    const sign = remainSign();
    const px = w * PIVOT_X;
    const py = h * PIVOT_Y;
    g.save();
    g.translate(dx + px, dy + py);
    if (k) {
      g.rotate(sign * REMAIN_ROT * k * Math.PI / 180);
      g.translate(sign * w * REMAIN_TX * k, h * REMAIN_TY * k);
    }
    g.translate(-px, -py);
    fn();
    g.restore();
  };

  const withBodyXform = (g, body, dx, dy, w, h, fn) => {
    const px = w * PIVOT_X;
    const py = h * PIVOT_Y;
    const s = body.held ? 1.05 : 1;
    g.save();
    g.translate(dx + px, dy + py);
    g.rotate((body.rot || 0) * Math.PI / 180);
    if (s !== 1) g.scale(s, s);
    g.translate(-px, -py);
    fn();
    g.restore();
  };

  const drawStack = (g, w, h, haloMul) => {
    parts.forEach((p) => {
      if (p.el.classList.contains("is-away")) return;
      drawPart(g, p, 0, 0, w, h, haloMul, true);
    });
    g.globalCompositeOperation = "source-over";
  };

  const punchMid = (g, dx, dy, w, h) => {
    const mid = parts.find((p) => p.part === "mid");
    if (!mid || !mid.mask) return;
    g.globalCompositeOperation = "destination-out";
    g.globalAlpha = 1;
    g.drawImage(mid.mask, dx, dy, w, h);
    g.globalCompositeOperation = "source-over";
  };

  const haloMulNow = () => {
    if (reduced) return 1;
    if (!remainSide()) return 1;
    return (performance.now() / 140 | 0) % 2 ? 0.12 : 1;
  };

  const flyStack = () => {
    const list = ["left", "right"].map((side) => flies[side]).filter(Boolean);
    list.sort((a, b) => {
      if (a.held !== b.held) return a.held ? 1 : -1;
      return (a.z || 0) - (b.z || 0);
    });
    return list;
  };

  const sizeLayer = (canvas, w, h) => {
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w;
      canvas.height = h;
    }
    const g = canvas.getContext("2d");
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.clearRect(0, 0, w, h);
    return g;
  };

  const logoAnchor = (homeR) => {
    if (home.classList.contains("is-fallen")) {
      if (!drop) return null;
      return { x: drop.x, y: drop.y, follow: drop };
    }
    return { x: homeR.left, y: homeR.top, follow: null };
  };

  const paintFly = (body, w, h, homeR) => {
    if (!body.side) return;
    const pw = Math.round(w * (1 + 2 * FLY_PAD));
    const ph = Math.round(h * (1 + 2 * FLY_PAD));
    const ox = (pw - w) / 2;
    const oy = (ph - h) / 2;
    const bots = sides[body.side].filter((p) => p.part.indexOf("bot") === 0);
    const tops = sides[body.side].filter((p) => p.part.indexOf("top") === 0);
    const botG = sizeLayer(body.botCanvas, pw, ph);
    withBodyXform(botG, body, ox, oy, w, h, () => {
      bots.forEach((p) => drawPart(botG, p, 0, 0, w, h, 1));
      punchParts(botG, tops, 0, 0, w, h);
    });
    const anchor = logoAnchor(homeR);
    if (anchor) {
      const mx = ox + (anchor.x - body.x) * (w / body.w);
      const my = oy + (anchor.y - body.y) * (h / body.h);
      if (anchor.follow) {
        withBodyXform(botG, anchor.follow, mx, my, w, h, () => {
          punchMid(botG, 0, 0, w, h);
        });
      } else {
        withRemainXform(botG, mx, my, w, h, () => {
          punchMid(botG, 0, 0, w, h);
        });
      }
    }
    const topG = sizeLayer(body.canvas, pw, ph);
    withBodyXform(topG, body, ox, oy, w, h, () => {
      tops.forEach((p) => drawPart(topG, p, 0, 0, w, h, 1));
    });
  };

  const punchBodyInto = (g, body, dx, dy, w, h) => {
    withBodyXform(g, body, dx, dy, w, h, () => {
      punchParts(g, sides[body.side], 0, 0, w, h);
    });
  };

  const punchTopsInto = (g, body, dx, dy, w, h) => {
    withBodyXform(g, body, dx, dy, w, h, () => {
      punchParts(g, sides[body.side].filter((p) => p.part.indexOf("top") === 0), 0, 0, w, h);
    });
  };

  const flyCanvases = (body) => [body.botCanvas, body.canvas].filter(Boolean);

  const paint = () => {
    const { w, h, ox, oy } = sizeBuf();
    ensureInk();
    const fallen = home.classList.contains("is-fallen");
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, buf.width, buf.height);
    if (!fallen) {
      withRemainXform(ctx, ox, oy, w, h, () => {
        drawStack(ctx, w, h, haloMulNow());
      });
    }
    const homeR = originRect();
    const stack = flyStack();
    document.body.classList.toggle("is-seal-fly", stack.length > 0 || !!drop);
    stack.forEach((body) => paintFly(body, w, h, homeR));
    for (let i = 0; i < stack.length; i += 1) {
      for (let j = i + 1; j < stack.length; j += 1) {
        const under = stack[i];
        const over = stack[j];
        const dx = (over.x - under.x) * (w / under.w);
        const dy = (over.y - under.y) * (h / under.h);
        flyCanvases(under).forEach((canvas) => {
          const fox = (canvas.width - w) / 2;
          const foy = (canvas.height - h) / 2;
          punchBodyInto(canvas.getContext("2d"), over, fox + dx, foy + dy, w, h);
        });
      }
    }
    if (!fallen) {
      stack.forEach((body) => {
        const dx = ox + (body.x - homeR.left) * (w / body.w);
        const dy = oy + (body.y - homeR.top) * (h / body.h);
        punchTopsInto(ctx, body, dx, dy, w, h);
      });
    }
  };

  const startFlicker = () => {
    if (flickerRaf || reduced) return;
    const tick = () => {
      if (!remainSide()) {
        flickerRaf = 0;
        paint();
        return;
      }
      paint();
      flickerRaf = requestAnimationFrame(tick);
    };
    flickerRaf = requestAnimationFrame(tick);
  };

  const maskHit = (data, nx, ny) => {
    const x = Math.max(0, Math.min(MW - 1, nx * MW | 0));
    const y = Math.max(0, Math.min(MH - 1, ny * MH | 0));
    return data[(y * MW + x) * 4 + 3] > 18;
  };

  const hitSide = (clientX, clientY) => {
    const r = seal.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    const nx = (clientX - r.left) / r.width;
    const ny = (clientY - r.top) / r.height;
    if (nx < 0 || ny < 0 || nx > 1 || ny > 1) return null;
    const trySide = (side) => {
      if (gone[side]) return false;
      if (maskBuf[side].length) return maskBuf[side].some((data) => maskHit(data, nx, ny));
      if (side === "right") return nx > 0.56 && ny > 0.22 && ny < 0.86;
      return nx < 0.44 && ny > 0.22 && ny < 0.86;
    };
    if (trySide("right")) return "right";
    if (trySide("left")) return "left";
    return null;
  };

  const originRect = () => seal.getBoundingClientRect();

  const placeFly = (body) => {
    const pad = body.side ? FLY_PAD : 0;
    const padX = body.w * pad;
    const padY = body.h * pad;
    const sr = body.side ? seal.getBoundingClientRect() : { left: 0, top: 0 };
    const apply = (el) => {
      if (!el) return;
      el.style.width = (body.w + padX * 2) + "px";
      el.style.height = (body.h + padY * 2) + "px";
      el.style.left = (body.x - padX - sr.left) + "px";
      el.style.top = (body.y - padY - sr.top) + "px";
      el.style.transform = body.side ? "" : `rotate(${body.rot || 0}deg)`;
    };
    apply(body.el);
    apply(body.botEl);
  };

  const offscreen = (body) => (
    body.y > innerHeight ||
    body.x > innerWidth ||
    body.x + body.w < 0 ||
    body.y + body.h < 0
  );

  const ripFlash = () => {
    if (reduced) return;
    document.body.classList.remove("is-seal-rip");
    void document.body.offsetWidth;
    document.body.classList.add("is-seal-rip");
    clearTimeout(ripTimer);
    ripTimer = setTimeout(() => document.body.classList.remove("is-seal-rip"), 220);
  };

  const makeLayer = (r, extraClass, host) => {
    const fly = document.createElement("div");
    fly.className = "os-seal-fly" + (extraClass ? " " + extraClass : "");
    fly.style.width = r.width + "px";
    fly.style.height = r.height + "px";
    fly.style.left = r.left + "px";
    fly.style.top = r.top + "px";
    const canvas = document.createElement("canvas");
    fly.appendChild(canvas);
    (host || document.body).appendChild(fly);
    return { el: fly, canvas };
  };

  const makeBody = (side, r, extraClass) => {
    const host = side ? seal : document.body;
    const over = makeLayer(r, extraClass + (side ? " is-over" : ""), host);
    if (side) over.el.setAttribute("data-seal-fly", side);
    const under = side ? makeLayer(r, extraClass + " is-under", host) : null;
    if (under) under.el.setAttribute("data-seal-fly", side);
    return {
      el: over.el,
      canvas: over.canvas,
      botEl: under && under.el,
      botCanvas: under && under.canvas,
      side,
      x: r.left,
      y: r.top,
      vx: 0,
      vy: 0,
      rot: 0,
      spin: 0,
      w: r.width,
      h: r.height,
      z: ++flyZ,
      held: false,
      samples: []
    };
  };

  const makeFly = (side) => {
    if (flies[side]) return flies[side];
    const r = originRect();
    const body = makeBody(side, r, "is-held");
    body.held = true;
    body.rot = side === "left" ? -6 : 6;
    sides[side].forEach((p) => p.el.classList.add("is-away"));
    flies[side] = body;
    placeFly(body);
    paint();
    startPhys();
    return body;
  };

  const dropHome = (toward = 1) => {
    if (drop || home.classList.contains("is-fallen")) return;
    const r = originRect();
    paint();
    const body = makeBody(null, r, "os-seal-drop is-flash");
    const { w, h } = sizeBuf();
    body.canvas.width = w;
    body.canvas.height = h;
    body.canvas.getContext("2d").drawImage(buf, 0, 0);
    home.classList.add("is-fallen");
    ctx.clearRect(0, 0, w, h);
    body.vx = (reduced ? 40 : 110) * toward;
    body.vy = reduced ? 380 : 70;
    body.rot = 11 * toward;
    body.spin = (reduced ? 40 : 96) * toward;
    drop = body;
    placeFly(body);
    sfx("logofall");
    setTimeout(() => body.el.classList.remove("is-flash"), reduced ? 40 : 90);
    startPhys();
  };

  const killFly = (side) => {
    const body = flies[side];
    if (!body) return;
    body.el.remove();
    if (body.botEl) body.botEl.remove();
    flies[side] = null;
  };

  const killDrop = () => {
    if (!drop) return;
    drop.el.remove();
    drop = null;
  };

  const applyBroken = () => {
    const wasRight = seal.classList.contains("is-right-gone");
    const wasLeft = seal.classList.contains("is-left-gone");
    const singleWas = (wasRight && !wasLeft) || (wasLeft && !wasRight);
    seal.classList.toggle("is-right-gone", gone.right);
    seal.classList.toggle("is-left-gone", gone.left);
    const singleNow = (gone.right && !gone.left) || (gone.left && !gone.right);
    if (singleNow && !singleWas) remainT0 = performance.now();
    ripFlash();
    if (gone.left && gone.right) {
      let toward = 1;
      if (wasRight && !wasLeft) toward = -1;
      else if (wasLeft && !wasRight) toward = 1;
      dropHome(toward);
    } else {
      paint();
    }
    if (singleNow) startFlicker();
    if ((gone.left || gone.right) && !rebuilding) armRebuild();
  };

  const armRebuild = () => {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(() => {
      if (holding) {
        armRebuild();
        return;
      }
      rebuild();
    }, reduced ? 900 : 3200);
  };

  const rebuild = () => {
    if (rebuilding) return;
    rebuilding = true;
    holding = null;
    document.body.classList.remove("is-seal-drag");
    killFly("left");
    killFly("right");
    killDrop();
    home.classList.remove("is-fallen");
    gone.left = false;
    gone.right = false;
    seal.classList.remove("is-right-gone", "is-left-gone");
    parts.forEach((p) => p.el.classList.remove("is-away"));
    sfx("open");
    seal.classList.remove("is-boot");
    void seal.offsetWidth;
    seal.classList.add("is-boot");
    paint();
    setTimeout(() => {
      seal.classList.remove("is-boot");
      rebuilding = false;
    }, reduced ? 80 : 780);
  };

  const startPhys = () => {
    if (physRaf) return;
    lastT = performance.now();
    const step = (now) => {
      const dt = Math.min(0.032, (now - lastT) / 1000) || 0.016;
      lastT = now;
      let live = false;
      const g = reduced ? 4400 : 2180;
      const integrate = (body) => {
        if (!body || body.held) return;
        live = true;
        body.vy += g * dt;
        body.vx *= reduced ? 0.991 : 0.9975;
        if (!reduced) {
          const flap = Math.sin(now * 0.01 + (body.z || 1) * 1.7);
          body.vx += flap * 70 * dt;
          body.spin += Math.sin(now * 0.008 + 1.1) * 22 * dt;
        }
        body.x += body.vx * dt;
        body.y += body.vy * dt;
        body.rot += (body.spin || 0) * dt;
        placeFly(body);
      };
      ["left", "right"].forEach((side) => {
        const body = flies[side];
        integrate(body);
        if (body && !body.held && offscreen(body)) killFly(side);
      });
      integrate(drop);
      if (drop && offscreen(drop)) killDrop();
      if (flies.left || flies.right || drop) paint();
      if (live) physRaf = requestAnimationFrame(step);
      else physRaf = 0;
    };
    physRaf = requestAnimationFrame(step);
  };

  const remember = (body, x, y) => {
    const t = performance.now();
    body.samples.push({ x, y, t });
    if (body.samples.length > 8) body.samples.shift();
  };

  const leanHeld = (body) => {
    const s = body.samples;
    if (s.length < 2) return body.rot || 0;
    const a = s[s.length - 2];
    const b = s[s.length - 1];
    const dt = Math.max(0.01, (b.t - a.t) / 1000);
    const vx = (b.x - a.x) / dt;
    const bias = body.side === "left" ? -7 : 7;
    const next = vx * 0.014 + bias;
    const cur = body.rot || 0;
    return cur + (Math.max(-26, Math.min(26, next)) - cur) * 0.28;
  };

  const throwFrom = (body) => {
    const s = body.samples;
    if (s.length < 2) {
      return { vx: body.side === "left" ? -140 : 140, vy: 260, spin: body.side === "left" ? -80 : 80 };
    }
    const a = s[Math.max(0, s.length - 4)];
    const b = s[s.length - 1];
    const dt = Math.max(0.016, (b.t - a.t) / 1000);
    let vx = (b.x - a.x) / dt;
    let vy = (b.y - a.y) / dt;
    vx = Math.max(-2600, Math.min(2600, vx));
    vy = Math.max(-1600, Math.min(3200, vy));
    const armX = (body.ox || body.w * 0.5) - body.w * 0.5;
    const armY = (body.oy || body.h * 0.5) - body.h * 0.5;
    let spin = (armX * vy - armY * vx) * 0.09;
    spin = Math.max(-620, Math.min(620, spin));
    return { vx, vy, spin };
  };

  const onDown = (e) => {
    if (e.button && e.button !== 0) return;
    if (rebuilding || holding) return;
    const side = hitSide(e.clientX, e.clientY);
    if (!side || gone[side]) return;
    e.preventDefault();
    e.stopPropagation();
    const r = originRect();
    const body = makeFly(side);
    body.held = true;
    body.ox = e.clientX - body.x;
    body.oy = e.clientY - body.y;
    body.homeX = r.left;
    body.homeY = r.top;
    body.w = r.width;
    body.h = r.height;
    body.samples = [];
    holding = { side, pid: e.pointerId, body };
    remember(body, e.clientX, e.clientY);
    document.body.classList.add("is-seal-drag");
    sfx("pull");
    try { seal.setPointerCapture(e.pointerId); } catch (_) { /* */ }
  };

  const onMove = (e) => {
    if (!holding || e.pointerId !== holding.pid) return;
    const body = holding.body;
    body.x = e.clientX - body.ox;
    body.y = e.clientY - body.oy;
    remember(body, e.clientX, e.clientY);
    body.rot = leanHeld(body);
    placeFly(body);
    paint();
    if (!gone[body.side]) {
      const dist = Math.hypot(body.x - body.homeX, body.y - body.homeY);
      if (dist >= Math.max(52, body.w * 0.13)) {
        gone[body.side] = true;
        applyBroken();
      }
    }
  };

  const onUp = (e) => {
    if (!holding || (e.pointerId != null && e.pointerId !== holding.pid)) return;
    const { side, body } = holding;
    holding = null;
    body.held = false;
    body.el.classList.remove("is-held");
    if (body.botEl) body.botEl.classList.remove("is-held");
    document.body.classList.remove("is-seal-drag");
    try { seal.releasePointerCapture(e.pointerId); } catch (_) { /* */ }
    const dx = body.x - body.homeX;
    const dy = body.y - body.homeY;
    const dist = Math.hypot(dx, dy);
    const need = Math.max(52, body.w * 0.13);
    if (!gone[side] && dist < need) {
      const startX = body.x;
      const startY = body.y;
      const startRot = body.rot || 0;
      const tx = body.homeX;
      const ty = body.homeY;
      const t0 = performance.now();
      const snap = (now) => {
        const u = Math.min(1, (now - t0) / (reduced ? 70 : 340));
        const k = 1 - Math.pow(1 - u, 3);
        const over = Math.sin(u * Math.PI) * 10;
        body.x = startX + (tx - startX) * k;
        body.y = startY + (ty - startY) * k - over;
        body.rot = startRot * (1 - k);
        placeFly(body);
        paint();
        if (u < 1) {
          requestAnimationFrame(snap);
          return;
        }
        killFly(side);
        sides[side].forEach((p) => p.el.classList.remove("is-away"));
        paint();
      };
      requestAnimationFrame(snap);
      return;
    }
    sfx("dropwing");
    if (!gone[side]) {
      gone[side] = true;
      applyBroken();
    }
    const thrown = throwFrom(body);
    body.vx = thrown.vx;
    body.vy = thrown.vy;
    body.spin = thrown.spin;
    if (Math.hypot(body.vx, body.vy) < 140) {
      body.vy = Math.max(body.vy, 280);
      body.vx += (body.side === "left" ? -1 : 1) * 90;
    }
    startPhys();
  };

  parts.forEach((p) => {
    p.artSrc = absUrl(p.artSrc);
    p.maskSrc = absUrl(p.maskSrc || cssUrl(p.el));
  });

  Promise.all(parts.map(async (p) => {
    try {
      p.art = await loadImg(p.artSrc);
    } catch (_) { /* */ }
    try {
      p.mask = await loadImg(p.maskSrc);
      if (p.mask && (p.side === "left" || p.side === "right")) {
        maskBuf[p.side].push(raster(p.mask));
      }
    } catch (_) { /* */ }
  })).then(() => {
    seal.dataset.sealReady = String(parts.filter((p) => p.mask && p.art).length);
    paint();
    seal.classList.add("is-composited");
    seal.dispatchEvent(new CustomEvent("fh:seal-ready", { bubbles: true }));
    startDepth();
    if (window.ResizeObserver) {
      new ResizeObserver(() => { paint(); }).observe(seal);
    }
    addEventListener("pointermove", (e) => {
      if (innerWidth <= 900) return;
      const span = depthCfg.tilt;
      const r = seal.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width / 2)) / Math.max(innerWidth * 0.5, 1);
      const dy = (e.clientY - (r.top + r.height / 2)) / Math.max(innerHeight * 0.5, 1);
      lookTX = Math.max(-span, Math.min(span, dx * span));
      lookTY = Math.max(-span * 0.72, Math.min(span * 0.72, dy * span * 0.72));
    }, { passive: true });
    addEventListener("fh:lab", (e) => {
      mergeWings(e.detail && e.detail.wings);
    });
    seal.addEventListener("pointerdown", onDown);
    document.addEventListener("pointermove", onMove);
    document.addEventListener("pointerup", onUp);
    document.addEventListener("pointercancel", onUp);
    seal.addEventListener("pointermove", (e) => {
      if (holding || rebuilding) return;
      const side = hitSide(e.clientX, e.clientY);
      seal.style.cursor = side ? "grab" : "default";
    });
  });
})();
